import { render, staticRenderFns } from "./CDangerArea.vue?vue&type=template&id=4eff8a93"
import script from "./CDangerArea.vue?vue&type=script&lang=js"
export * from "./CDangerArea.vue?vue&type=script&lang=js"
import style0 from "./CDangerArea.vue?vue&type=style&index=0&id=4eff8a93&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eff8a93')) {
      api.createRecord('4eff8a93', component.options)
    } else {
      api.reload('4eff8a93', component.options)
    }
    module.hot.accept("./CDangerArea.vue?vue&type=template&id=4eff8a93", function () {
      api.rerender('4eff8a93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CDangerArea.vue"
export default component.exports